// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5871":"270b863f","7756":"5eb0cb70"}[chunkId] + ".chunk.css";
};